import{Z as o,d as s}from"./p-DGP_EXO5.js";const t=o;const p=s;export{t as ZprModal,p as defineCustomElement};
//# sourceMappingURL=zpr-modal.js.map